<template>
	<div v-if="!isLocked">
		<div
			v-if="!manager.isAvailable()"
			class="cart-action"		
		>
			<div
				class="disabled"
				v-html="`ANDATO A RUBA :)`"
			/>
		</div>

		<div
			v-if="manager.isAvailable() && actionable === false"
			class="cart-action"		
		>
			<div
				class="enabled available-text"
				v-html="`DISPONIBILE SU ALTRE DATE DI CONSEGNA`"
			/>
		</div>

		<div
			v-if="manager.isAvailable() && actionable !== false"
			class="cart-action"
		>
			<template v-if="manager.getCurrentQuantity() > 0">
				<div
					class="flex flex-vcenter"
				>
					<CTA
						class="full"
						:disabled="updating"
						@click="manager.remove(); resetCount()"
						:content="`-`"
					/>

					<div class="quantity">
						<span><b>{{ manager.getCurrentQuantity() }} {{ manager.getLabel() }}</b></span>
					</div>

					<CTA
						class="full"
						:disabled="updating || manager.isOutOfStock()"
						@click="manager.add(); triggerSnackbar()"
						:content="`+`"
					/>
				</div>
			</template>

			<template v-else>
				<CTA
					class="full not-in-box"
					:disabled="updating"
					@click="manager.add(); triggerSnackbar()"
					:content="$mq.isDesktop() ? $t('components.checkout.cart.edit.desktop') : $t('components.checkout.cart.edit.mobile')"
				/>
			</template>

		</div>
	</div>
</template>

<script>

import { extraAction } from '../../mixins/extraAction'
import { orderAction } from '../../mixins/orderAction'
import { Repository } from '../../services/Repository'
import { menuStore } from '../../store/menuStore'

export default {
	mixins: [
		extraAction,
		orderAction
	],
	props: {
		action: {
			type: Boolean,
			default: true
		},
		item: {
			type: Object,
			required: true
		},
		type: {
			type: String,
			required: true
		}
	},
	data() {
		return {		
			menuStore: menuStore.state,
			inMenu: false
		}
	},
	watch: {
		'menuStore.menu': {
			handler() {
				this.type == 'recipe' && this.checkMenu()
			}
		}
	},
	computed: {
		actionable() {

			if (this.type == 'recipe' && !this.inMenu) {
				return false
			}

			return this.action
		},
		user () {
			return this.$root.user
		},
		isLocked() {
			return this.user && this.user.subscription && this.user.subscription.locked
		},
		manager() {
			let t = {
				recipe: {
					getLabel: () => {
						return 'Porzioni Aggiunte'
					},
					isOutOfStock: () => {
						return !this.$_orderAction_isOneMoreRecipeAvailableBySingle(this.item)
					},
					isAvailable: () => {
						return this.item.available || this.isRecipeInBox(this.item)
					},
					getCurrentQuantity: () => {
						return this.$_orderAction_getRecipeQuantity(this.item) * 2 
					},
					remove: () =>  {
						this.$_orderAction_removeRecipe(this.item)
					},
					add: () => {
						this.$emit('update:updating', true)

				        let rep = new Repository();

				        if (!this.order) {
					        rep.retrieveOrCreateOrder().then(i => {
								this.$_orderAction_addRecipe(this.item)
					        }).finally(i => {
								this.$emit('update:updating', false)
					        })
				    	} else {
							this.$_orderAction_addRecipe(this.item)
						}
					}
				},
				extra: {
					getLabel: () => {
						return '';
					},
					isOutOfStock: () => {
						return this.$_extraAction_outOfStock(this.item)
					},
					isAvailable: () => {

						return this.$_extraAction_extraAvailable(this.item)
					},
					getCurrentQuantity: () => {
						return this.$_extraAction_quantityExtraInOrder(this.item.id)
					},
					remove: () =>  {
						this.$_extraAction_remove(this.item)
					},
					add: () => {
						this.$emit('update:updating', true)
				        let rep = new Repository();

				        if (!this.order) {
					        rep.retrieveOrCreateOrder().then(i => {
					   
								this.$_extraAction_add(this.item)
					        }).finally(i => {	

								this.$emit('update:updating', false)

					        })
				    	} else {
							this.$_extraAction_add(this.item)

				    	}

					}
				}
			}

			return t[this.item.type];
		}
	},
	methods: {
		checkMenu() {
			this.inMenu = this.menuStore.menu.recipes.findIndex(i => { 
				return i.id == this.item.id
			}) !== -1
		},

		triggerSnackbar() {
				if (this.type == 'recipe' && !this.user.email.includes('guest.quomi.it') && this.order.getPlanPricePerPortion().toFixed(2) != "4.45"){
					window.dispatchEvent(new CustomEvent('trigger-snackbar-recipes', { 
					bubbles: true
					}));
				}else if (!this.user.email.includes('guest.quomi.it') && this.order.getPlanPricePerPortion().toFixed(2) != "4.45") {
					window.dispatchEvent(new CustomEvent('trigger-snackbar', { 
						bubbles: true
					}));
				}	
		},
		resetCount() {
			if (this.type == 'recipe'){
				window.dispatchEvent(new CustomEvent('reset-count', { 
        	bubbles: true
      	}));
			}
		}
	},
	mounted(){
		if (this.type === 'recipe') {
			menuStore.loadCurrentMenu().then(i => {
				this.checkMenu()
			})
		}
	}
}

</script>

<style scoped>
	
	.available-text {
		color: var(--quomi-primary);
	}

	.cart-action {
		display: inline-block;
	}

	.cart-action .flex-right {
		display: flex;
	}

	.cart-action button {
		padding: 5px 20px;
		background-color: var(--quomi-primary);
		color: white;
		border: 1.5px solid var(--quomi-primary);
	}

	.cart-action .btn:not(.full) {
		font-size: 18px;
		padding: 3px 15px;
	}

	.cart-action button.full {
		background-color: var(--quomi-primary);
		color: white;
	}

	.cart-action .quantity {
		padding: 5px 20px;
		z-index: 1;
	}

	.disabled {
		padding: 5px 20px;
		margin-top: 10px;
		color: var(--quomi-orange);
	}

	@media (max-width: 425px) {
		.cart-action .quantity {
		padding: 5px 10px;
	}
	}
</style>
